import { render } from "./product-single-3.vue?vue&type=template&id=56c8b89c&scoped=true"
import script from "./product-single-3.vue?vue&type=script&lang=js"
export * from "./product-single-3.vue?vue&type=script&lang=js"

import "./product-single-3.vue?vue&type=style&index=0&id=56c8b89c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c8b89c"]])

export default __exports__